import axios, { AxiosResponse } from 'axios';
import fetchOtpAccessToken from '../fetchOtpAccessToken';

export default async function injectNetworkErrorHandler(
  error: unknown,
): Promise<AxiosResponse> {
  // Ignore cancels
  if (axios.isCancel(error)) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw error;
  }

  if (axios.isAxiosError(error) && error.response?.status === 401) {
    // get new authToken
    const accessToken = await fetchOtpAccessToken();

    if (!error.config) {
      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw error;
    }

    // eslint-disable-next-line no-param-reassign
    error.config.headers = error.config.headers || {};

    // eslint-disable-next-line no-param-reassign
    error.config.headers.Authorization = `Bearer ${accessToken}`; // update bearer

    if (
      ['post', 'put', 'patch'].includes(error.config.method || '') &&
      typeof error.config.data === 'string'
    ) {
      // eslint-disable-next-line no-param-reassign
      error.config.data = JSON.parse(error.config.data);
    }

    // axios retry
    return axios.request(error.config);
  }

  // eslint-disable-next-line @typescript-eslint/no-throw-literal
  throw error;
}
